// extracted by mini-css-extract-plugin
module.exports = {"error-404":"__404_error-404__Sil4m","image":"__404_image__MxwHr"};